import { ALLOW_COOKIE } from 'constants';
import Storage from 'utilities/storage';

export const logout = ({ accessToken, logoutAction }) => {
    const token = accessToken || (ALLOW_COOKIE && Storage.cookies.get('accessToken'));
    if (!token) return;
    logoutAction(token);
};
